import { createJSONStorage, persist } from "zustand/middleware";
import { createStore } from "zustand/vanilla";
import type { UserType } from "@/types/auth";

export type UserState = {
	user: UserType | null;
};

export type UserActions = {
	saveUser: (data: UserType) => void;
	clearUser: () => void;
};

export type UserStore = UserState & UserActions;

export const defaultInitState: UserState = {
	user: null,
};

export const createUserStore = (initState?: UserState) => {
	return createStore<UserStore>()(
		persist(
			(set) => ({
				...(initState ?? defaultInitState),
				saveUser: (user) => set(() => ({ user })),
				clearUser: () => set(() => ({ user: null })),
			}),
			{
				name: "pos-user-storage",
				storage: createJSONStorage(() => localStorage),
			},
		),
	);
};
